var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionGrisDeverrouillerPlacard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3,13.6c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2s-2.2-1-2.2-2.2l0,0C7.1,14.6,8.1,13.6,9.3,13.6C9.3,13.6,9.3,13.6,9.3,13.6  M18,0.5c-3,0-5.5,2.5-5.5,5.5c0,0,0,0,0,0v2.2H2.7c-1.2,0-2.2,1-2.2,2.2v11c0,1.2,1,2.1,2.2,2.1h13.1c1.2,0,2.2-1,2.2-2.2V10.4 c0-1.2-1-2.2-2.2-2.2l0,0h-1.1V6c-0.1-1.8,1.3-3.4,3.1-3.5s3.4,1.3,3.5,3.1c0,0.1,0,0.2,0,0.4v2.2h2.2V6C23.5,3,21.1,0.5,18,0.5 C18,0.5,18,0.5,18,0.5 M15.8,10.4v11H2.7v-11H15.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionGrisDeverrouillerPlacard);
export default __webpack_public_path__ + "static/media/action_gris_deverrouiller-placard.12f3b8db.svg";
export { ForwardRef as ReactComponent };